import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState, useRef } from "react";
import { Accordion, Alert, Button, Card, Col, Form, FormGroup, Modal, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { addNewCommand, getCommandByAttachmentID, deleteMessage, editCommand, doneCommand, addNewMessage, getCommand } from "../../store/api/CommandsAPI";
import Loader from "react-loader-spinner";
import { PlusCircle, Link45deg, PersonCircle, Trash, PersonLinesFill, Check2, Check2Square, List, CheckLg, DashCircle, ExclamationTriangle, FileEarmarkText } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import momentJalaali from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import ModalSelectUser from "./ModalSelectUser";
import { allAttachmentTypes, attachFile, downloadFile, setDialog, translateError } from "../../store/api/CommonFunctions";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentAlt, faTimes } from "@fortawesome/free-solid-svg-icons";

const ModalCommands = (props) => {
    const { popData, setPopData } = props;
    const [pending, setPending] = useState(false);
    const { register, handleSubmit, errors } = useForm();
    const { attachmentType, attachmentID, show, onAddEdit, id, onDone } = popData;
    const minDate = momentJalaali().subtract(1, "day");
    const dispatch = useDispatch();
    const [popUser, setPopUser] = useState({
        show: false
    })
    const [command, setCommand] = useState({ AlarmDate: momentJalaali().add(5, "minute"), CommandRecipients: [] });
    if (!command.PAttachmentType) {
        command.PAttachmentType = allAttachmentTypes[attachmentType?.replace("Invoice", "").replace("Formal", "")];
    }
    const messageData = useRef({});
    const messageAttachment = useRef();
    const commandAttachment = useRef();
    const [err, setError] = useState({});
    const [showNew, setNewShow] = useState(false);
    function close() {
        setCommand({ AlarmDate: momentJalaali().add(5, "minute"), CommandRecipients: [] });
        setPopData({
            show: false
        })
        setError({});
        setPending(false);
    }
    const selectRecipients = (list) => {
        if (Array.isArray(list)) {
            list.forEach(l => {
                if (!command.CommandRecipients.some(c => Number(c.RecipientID) === Number(l))) {
                    command.CommandRecipients.push({ RecipientID: l });
                }
            });
        }
    }
    const addMessage = () => {
        let f = messageAttachment.current.files;
        if (!messageData.current.Message || messageData.current.Message === "") {
            setError({ submitError: "متن پیام وارد نشده است" });
            return;
        }
        setCommand({ ...command, CommandMessages: "PENDING" });
        const onSuccess = (res) => {
            if (res?.Error || res?.Message) {
                setError({ submitError: translateError(res.Error ?? res.Message) });
            }
            else {
                if (Number(command.ID) > 0) {
                    getCommand(command.ID, initCommand)
                }
                else if (Number(attachmentID) > 0) {
                    getCommandByAttachmentID(attachmentID, attachmentType, initCommand);
                }
                messageData.current = {};
                setError({});
            }
        }
        if (f.length > 0) {
            dispatch(attachFile(messageAttachment.current, command.ID, "command", onSuccess, messageData.current.Message));
        }
        else {
            messageData.current.CommandID = command.ID;
            dispatch(addNewMessage(messageData.current, onSuccess));
        }
        setNewShow(false);
    }
    const attachNewFile = (res) => {
        let f = commandAttachment.current.files;
        const addRes = { ...res };
        const onSuccess = (res) => {
            if (res?.Error || res?.Message) {
                setError({ submitError: translateError(res.Error ?? res.Message) })
            }
            else if (Number(addRes.ID) > 0) {
                getCommand(addRes.ID, initCommand);
            }
            else if (Number(attachmentID) > 0) {
                getCommandByAttachmentID(attachmentID, attachmentType, initCommand);
            }
            if (typeof onAddEdit === "function") {
                onAddEdit();
            }
            setPending(false);
        }
        if (f.length > 0 && addRes.MessageID) {
            dispatch(attachFile(commandAttachment.current, addRes.MessageID, "command", onSuccess, "AddCommand", true));
        }
        else if (addRes.ID) {
            setPending(false);
            getCommand(addRes.ID, initCommand);
            if (typeof onAddEdit === "function") {
                onAddEdit();
            }
        }
        else if (addRes?.Error || addRes?.Message) {
            setPending(false);
            setError({ submitError: translateError(res.Error ?? res.Message) })
        }
        else if (Number(attachmentID) > 0) {
            setPending(false);
            getCommandByAttachmentID(attachmentID, attachmentType, initCommand);
        }

    }
    const showUserPop = () => {
        if (!(Number(command?.ID) > 0)) {
            setPopUser({ show: true, selectUser: selectRecipients });
        }
        else {
            //dispatch(setSelectedUserPop({ show: true, userList: command.Recipients }));
        }
    }
    const changeCommand2Done = () => {
        const onSuccess = (res) => {

            if (res?.Error || res?.Message) {
                setError({ submitError: translateError(res.Error ?? res.Message) });
            }
            else {
                if (Number(id) > 0) {
                    getCommand(id, initCommand)
                }
                else if (Number(attachmentID) > 0) {
                    getCommandByAttachmentID(attachmentID, attachmentType, initCommand);
                }
                setError({});
                if (typeof onDone === "function") {
                    onDone();
                }
            }
        }
        dispatch(doneCommand(command.ID, onSuccess));
    }
    const saveCommand = (data) => {

        let alarmDateIseEMpty = !(Number(command?.ID) > 0) && ((command.AlarmDate ?? "") === "");
        let recipientIsEmpty = !(Number(command?.ID) > 0) && (!command.CommandRecipients || command.CommandRecipients.length === 0);

        setError({
            Alarm: alarmDateIseEMpty ? "N" : null,
            Recipients: recipientIsEmpty ? "N" : null,
        });
        if (alarmDateIseEMpty || recipientIsEmpty) {
            return;
        }
        if (attachmentID && attachmentID !== "0") {
            data.AttachmentID = attachmentID;
        }
        if (attachmentType && attachmentType !== "0") {
            data.AttachmentType = attachmentType;
        }
        const pattern = /^([0-9]{4}\/[0-9]{2}\/[0-9]{2} [0-9]{2}:[0-9]{2})/
        if (!Number(command.ID) > 0 && pattern.test(command.AlarmDate)) {
            data.AlarmDate = command.AlarmDate
        }
        data.CommandRecipients = command.CommandRecipients;
        setPending(true);
        if (Number(command.ID) > 0) {
            data.CommandID = command.ID;
            data.MessageID = command.MessageID;
            const onSuccess = (res) => {
                onAddEdit(res);
                setPending(false);
            }
            dispatch(editCommand(data, onSuccess));
        }
        else {
            data.CommandMessages = [];
            let attachFileName = "";
            if (commandAttachment.current.files.length > 0) {
                attachFileName = commandAttachment.current.files[0].name;
            }
            data.CommandMessages.push({ Message: data.Message, AttachmentFileName: attachFileName });
            addNewCommand(data, attachNewFile);
        }

    }
    const initCommand = (cmd) => {
        if (Number(cmd.ID) > 0) {
            cmd.PAttachmentType = allAttachmentTypes[cmd.AttachmentType?.replace("Invoice", "").replace("Formal", "")];
            setCommand({ ...cmd, MessageID: cmd.CommandMessageID })
        }
    }
    const onDeleteSuccess = (item) => {
        if (item?.IsPending) {
            setCommand({ ...command, CommandMessages: "PENDING" });
        }
        else if (item) {
            setCommand({ ...command, CommandMessages: command.CommandMessages.filter(m => m.ID !== item.ID) });
        }
    }
    function showNewDiv() {
        setNewShow(true);
        const divCol = document.getElementById('divCommandDescCollapse')
        if (divCol.classList.contains('show')) {
            const divCommandDesc = document.getElementById("divCommandDesc");
            divCommandDesc.click();
        }

    }
    function cancelMessage() {
        setNewShow(false);
        const divCol = document.getElementById('divCommandDescCollapse')
        if (!divCol.classList.contains('show')) {
            if ((command.CommandMessages?.length ?? 0) === 0) {
                const divCommandDesc = document.getElementById("divCommandDesc");
                divCommandDesc.click();
            }
        }
    }
    function showCommandAttachment() {
        switch (command.AttachmentType.toLowerCase()) {
            case "customer":
                window.open(`/CRM/AddEditCustomer/${command.AttachmentID}`);
                break;
            case "pre_customer":
                window.open(`/CRM/AddEditPreCustomer/${command.AttachmentID}`);
                break;
            case "acc_doc":
                window.open(`/Accounting/AddEditDocument/${command.AttachmentID}`);
                break;
            case "install":
                window.open(`/Services/Service/${command.AttachmentID}/install`);
                break;
            case "repair":
                window.open(`/Services/Service/${command.AttachmentID}/repair`);
                break;
            default:
                if (command.AttachmentType.toLowerCase().includes("invoice")) {
                    const invoiceType = command.AttachmentType.replace("Invoice", "").replace("Formal", "");
                    window.open(`/Sale/Invoice/${invoiceType}/${command.AttachmentID}/${command.AttachmentType.toLowerCase().includes("formal")}`)
                }

        }
    }
    const popover = (
        (<Popover id="popover-basic" style={{ maxWidth: "350px", minWidth: "350px", fontFamily: "Vazir", borderBottom: "3px solid #af5386" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                لیست دریافت کنندگان</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <Table className="fixedTable">
                    <thead>
                        <tr>
                            <th style={{ width: "50%" }}>نام کاربر</th>
                            <th style={{ width: "25%" }}>خوانده شده</th>
                            <th style={{ width: "25%" }}>انجام شده</th>
                        </tr>
                    </thead>
                    <tbody>
                        {command.Recipients && Array.isArray(command.Recipients) && command.Recipients.map((item, i) => {
                            return (<tr key={i} className="resultTableRow">
                                <td style={{ width: "50%" }}>{item.RecipientName}</td>
                                <td style={{ width: "25%" }}> <input type="checkbox" readOnly checked={item.IsRead} /></td>
                                <td style={{ width: "25%" }}><input type="checkbox" readOnly checked={item.IsDone} /></td>
                            </tr>)
                        }
                        )}
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    useEffect(() => {
        /*else*/
        if (Number(id) > 0) {
            getCommand(id, initCommand);
        }
        else if (Number(attachmentID) > 0)
            getCommandByAttachmentID(attachmentID, attachmentType, initCommand);
        // else if (Number(id) > 0) {
        //     getCommand(id, initCommand);
        // }
    }, [attachmentID, id]);
    return (
        <Modal size={Number(command?.ID) > 0 && command?.CommandMessages && command?.CommandMessages.length > 0 ? "xl" : "lg"} show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCommentAlt} size="lg" />&nbsp; ثبت/ویرایش دستور کار {command?.PAttachmentType}
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ textAlign: "right" }}>
                <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                {command === "PENDING" &&
                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={40} />
                }
                {command !== "PENDING" &&
                    <Fragment>
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Accordion.Toggle id="divCommandDesc" as={Card.Header} eventKey="0" style={{ backgroundColor: "#b6b6b6", textAlign: "right", fontSize: "14px" }}>
                                    شرح دستور کار
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="0" id="divCommandDescCollapse">
                                    <Card.Body style={{ textAlign: 'right' }}>
                                        {Number(command?.ID) > 0 &&
                                            <div>
                                                <label style={{ color: "blue", fontSize: "12px" }}>{"تاریخ ایجاد: " + command.pCreationDate}</label>
                                                <label style={{ color: "blue", fontSize: "12px", float: "left" }}>{"ایجاد کننده: " + command.CreateByName}</label>
                                            </div>
                                        }
                                        <form onSubmit={handleSubmit(saveCommand)}>
                                            <Row>
                                                <Col md={4} className="form-group">
                                                    <label>تاریخ نمایش</label>
                                                    <DatePicker name="AlarmDate" isGregorian={false} timePicker={true} className="form-control" inputJalaaliFormat="jYYYY/jMM/jDD HH:mm"
                                                        value={command?.AlarmDate ? momentJalaali(command.AlarmDate)
                                                            : momentJalaali().add(5, "minute")} disabled={Number(command.ID) > 0}
                                                        onChange={value => { command.AlarmDate = value.local("en").format("YYYY/MM/DD HH:mm") }} min={minDate} />
                                                    {err?.AlarmDate && <small className="errors">تاریخ نمایش الزامی است</small>}
                                                </Col>
                                                <Col md={4} className="form-group col-sm-3 col-xs-3">
                                                    <label>اولویت</label>
                                                    <select className="form-control" defaultValue={command?.Priority ?? 2}
                                                        name="Priority" ref={register({})}>
                                                        <option value="">انتخاب کنید</option>
                                                        <option value={1}>پایین</option>
                                                        <option value={2}>عادی</option>
                                                        <option value={3}>بالا</option>
                                                        <option value={4}>خیلی فوری</option>
                                                    </select>
                                                    {errors?.Priority && <small className="errors">انتخاب اولویت الزامی است</small>}
                                                </Col>
                                                {!(Number(command?.ID) > 0) && (command?.AttachmentFileName ?? "" === "") &&
                                                    <Col md={4} className="form-group">
                                                        <label>پیوست</label>
                                                        <input type="file" className="form-control" ref={commandAttachment} />
                                                    </Col>
                                                }
                                                <Col md={4} className="form-group">
                                                    <label>موضوع دستور کار</label>
                                                    <input className="form-control" type="text" defaultValue={command?.Subject ?? ""}
                                                        ref={register({ required: true })} name="Subject" />
                                                    {errors.Subject && <small className="errors">موضوع دستور کار الزامی است</small>}
                                                </Col>
                                                <Col md={12} className="form-group">
                                                    <label>متن دستور کار</label>
                                                    <Form.Control as="textarea" className="scThin" style={{ fontSize: "13px", textAlign: "justify" }} rows={(command?.Message?.length ?? 0) / 171 + 1} defaultValue={command?.Message ?? ""}
                                                        name="Message" ref={register({ required: true })} onChange={e => setCommand({ ...command, Message: e.target.value })} />
                                                    {errors.Message && <small className="errors">متن دستور کار الزامی است</small>}
                                                </Col>
                                            </Row>

                                            <div className="mt-1">
                                                {!(Number(command?.ID) > 0) &&
                                                    <Button className="group-Btn" onClick={showUserPop}><PersonLinesFill size={14} />&nbsp;دریافت کننده ها </Button>
                                                }
                                                <Button variant="success" className="group-Btn" type="submit" disabled={pending}><Check2 size={14} />&nbsp;ثبت اطلاعات</Button>
                                                {command?.AttachmentType &&
                                                    <Button className="group-Btn" onClick={showCommandAttachment} variant="info"><FileEarmarkText size={18} />&nbsp;نمایش {command.PAttachmentType}</Button>
                                                }
                                                {Number(command?.ID) > 0 && !command?.IsDone &&
                                                    <Button className="group-Btn" onClick={changeCommand2Done}><Check2Square size={14} />&nbsp;انجام شد</Button>
                                                }
                                                {err.Recipients && <div className="errors">لیست دریافت کنندگان خالی است</div>}
                                                {err.submitError && <Alert className="mt-2" variant="danger"><ExclamationTriangle size={18} />&nbsp; {err.submitError}</Alert>}
                                            </div>
                                        </form>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                        {Number(command?.ID) > 0 &&
                            <Fragment>
                                <label className="mt-3">پیام ها</label>
                                &nbsp;
                                {!showNew && <PlusCircle size={18} style={{ cursor: "pointer" }} color="red" onClick={showNewDiv} />}
                                {command.AttachmentFileName && command.AttachmentFileName.length > 0 &&
                                    <Link45deg size={23} style={{ float: "left", marginTop: "10px", color: "blue", cursor: "pointer" }} onClick={() => downloadFile(command.CommandMessageID, "command")} />
                                }
                                <OverlayTrigger trigger="click" placement="right" overlay={popover} rootClose>
                                    <PersonLinesFill size={21} style={{ float: "left", marginTop: "10px", color: "#b700ff", cursor: "pointer" }} onClick={showUserPop} />
                                </OverlayTrigger>
                                <hr style={{ margin: "0px" }} />

                                <Row style={{ display: showNew ? "flex" : "none", overflow: "hidden" }}>
                                    <FormGroup>
                                        <label>متن پیام</label>
                                        <Form.Control as="textarea" style={{ fontSize: "13px" }} onChange={(e) => messageData.current.Message = e.target.value} rows={3} />
                                    </FormGroup>
                                    <Col md={6} className="form-group">
                                        <label>پیوست</label>
                                        <input className="form-control" style={{ fontSize: "13px" }} type="file" ref={messageAttachment} />
                                    </Col>
                                    <div className="mt-2 mb-2">
                                        {err.msgError && <div className="errors mb-1">{err.msgError}</div>}
                                        <Button variant="info" className="group-Btn" onClick={addMessage}><CheckLg />&nbsp;ثبت پیام</Button>
                                        <Button variant="danger" className="group-Btn" onClick={cancelMessage}><DashCircle size={16} />&nbsp;انصراف</Button>
                                    </div>
                                </Row>
                                {command?.CommandMessages && command.CommandMessages.length > 0 &&
                                    <div className="mt-1 scThin" style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "40vh", display: showNew ? "none" : "block" }}>

                                        <Fragment>
                                            {command.CommandMessages === "PENDING" && <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={40} />}
                                            {command?.CommandMessages && Array.isArray(command.CommandMessages) && command.CommandMessages.map((item, i) =>
                                                <div key={i} className="row">
                                                    <Card className="mt-1">
                                                        <Card.Header style={{ backgroundColor: i % 2 === 0 ? "rgb(151 179 223)" : "#ced5e0" }}>
                                                            <PersonCircle />
                                                            &nbsp;
                                                            <span>{item.CreateByName}</span>
                                                            &nbsp;
                                                            <span style={{ color: "#575555", fontSize: "10px" }}>{item.CreationHour + " " + item.pCreationDate} </span>
                                                            &nbsp;
                                                            {item.AttachmentFileName && item.AttachmentFileName.length > 0 &&
                                                                <Link45deg size={20} color="blue" style={{ cursor: "pointer" }} onClick={() => {
                                                                    downloadFile(item.ID, "command");
                                                                }} />}
                                                            &nbsp;
                                                            {item.CanDelete &&
                                                                <Trash color="red" style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        dispatch(setDialog({
                                                                            status: 'show',
                                                                            arrayBtn: ['yes', 'no'],
                                                                            dialogTitle: 'حذف پیام',
                                                                            dialogText: 'آیا از حذف مطمئن هستید؟',
                                                                            okOperation: deleteMessage(item.ID, (isPending) => onDeleteSuccess({ ...item, IsPending: isPending }))
                                                                        }))
                                                                    }
                                                                    }
                                                                />}
                                                        </Card.Header>
                                                        <Card.Body >
                                                            <Form.Control as="textarea" style={{ fontSize: "13px" }} rows={2} defaultValue={item.Message} />
                                                        </Card.Body>
                                                    </Card>
                                                </div>

                                            )
                                            }
                                        </Fragment>


                                    </div>}
                            </Fragment>
                        }
                    </Fragment>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalCommands;